// adding employee form
export const addingEmployeeForm = (
  branchOption,
  roleOptions,
  approvalStatusOptions = [],
) => {
  return {
    "": [
      {
        textField: true,
        gridSize: 6,
        required: true,
        star: "*",
        placeholder: "Enter Email Id",
        type: "email",
        name: "companyEmployeeEmail",
        label: "Email ID",
      },
      {
        textField: true,
        gridSize: 6,
        placeholder: "Enter Name",
        required: true,
        type: "text",
        name: "name",
        label: "Name",
        star: "*",
      },
      {
        textField: true,
        gridSize: 6,
        placeholder: "9999999999",
        maxLength: 10,
        required: true,
        countrycode: true,
        type: "number",
        name: "phoneNumber",
        label: "Phone Number",
        star: "*",
      },
      {
        textField: true,
        gridSize: 6,
        placeholder: "Enter Employee Id",
        type: "text",
        name: "employeeId",
        label: "Employee ID",
      },
      {
        textField: true,
        gridSize: 6,
        placeholder: "Enter Department/ Project Code/ Cost Code",
        type: "text",
        name: "code",
        label: "Department/ Project Code/ Cost Code",
      },
      {
        options: true,
        required: true,
        gridSize: 6,
        placeholder: "Select Role",
        type: "text",
        name: "role",
        label: "Role",
        star: "*",
        menuOptions:
          roleOptions && roleOptions.length > 0
            ? roleOptions
            : [
                { label: "Admin", value: 2 },
                { label: "Employee", value: 3 },
                { label: "Finance", value: 4 },
              ],
      },
      {
        options: true,
        gridSize: 6,
        required: true,
        star: "*",
        placeholder: "Choose your branch",
        type: "text",
        name: "branchName",
        label: "Branch",
        menuOptions: branchOption,
      },
      {
        radio: true,
        required: true,
        gridSize: 6,
        label: "Billing Mode",
        name: "billingTypeAccess",
        values: [
          { value: 1, label: "Bill to Self" },
          { value: 2, label: "Bill to Company" },
          { value: 3, label: "Both" },
        ],
      },
      {
        options: true,
        required: true,
        gridSize: 4,
        placeholder: "Select Approval Status",
        type: "text",
        name: "approvalStatus",
        label: "Approval Status",
        star: "*",
        menuOptions:
          approvalStatusOptions.length > 0
            ? approvalStatusOptions
            : [
                { label: "Pending", value: "Pending" },
                { label: "Approved", value: "Approved" },
                { label: "Rejected", value: "Rejected" },
              ],
      },
    ],
  };
};
